import { FunctionComponent, useState } from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';
import ButtonProgress from '../ButtonProgress/ButtonProgress';

const AuthChangePage: FunctionComponent<{ onLogout: (callback: ()=>void)=>void }> = ({ onLogout }) => {
  const [loading, setLoading] = useState(false);
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ height: '100vh', padding: '24px' }}
    >
      <Paper
        variant="outlined"
        style={{
          textAlign: 'center',
          height: '90vh',
          minHeight: '350px',
          width: '100%',
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ height: '100%' }}
        >
          <div>
           <ErrorOutline color="error" style={{ fontSize: 200 }} />
          </div>
          <Typography color="textSecondary" variant="h4">
            Your account has been changed. Please login again.
          </Typography>
          <ButtonProgress
            isLoading={loading}
            variant="outlined"
            color="primary"
            style={{ marginTop: 20 }}
            onClick={()=>{
              setLoading(true);
              onLogout(()=>{
                setLoading(false);
              });
            }}
          >
            Logout
          </ButtonProgress>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default AuthChangePage;
